export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "ko",
    "resource": {
      "Language": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["언어"])},
      "Asia Pacific": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["아시아 태평양"])}
    }
  })
}
